import {Injectable} from '@angular/core';
import {ItemSelectorBuilder} from "./item-selector-builder";
import * as _ from "lodash";

@Injectable()
export class SaraSelectorService {

    newItemSelectorBuilder() {
        return new ItemSelectorBuilder();
    };

    getItemsForSelector(collection, selectedItems, nameGenerator, idGenerator?:Function) {
        var items = {};
        // create collection of items for the selector
        _.each(collection, function (obj) {
            var name = nameGenerator(obj);
            items[(!idGenerator)?obj.oid:idGenerator(obj)] = {name: name};
        });
        // mark items as selected
        if (selectedItems) {
            _.each(selectedItems, function (selectedItemOid) {
                if (items[selectedItemOid]) {
                    items[selectedItemOid].checked = true;
                } else {
                    console.warn(selectedItemOid + ' is not present in items collection.');
                }
            });
        }
        return items;
    };
}



// WEBPACK FOOTER //
// ./public/upgrade/shared/sara-selector/sara-selector.service.ts